module.exports = __webpack_public_path__ + "static/18.1_Reformation_of_Christianity-44cddce29b91dcc2afea78d3aa431a04.pdf";